import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const mcHammer: string =
  'https://mc-hammer.precisionnutrition.com/api/forms/fb2d2b61-54d6-43e4-9013-95cc1b60cee9';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  constructor(private http: HttpClient) {}

  submit = (name, email, token) => {
    let body = new URLSearchParams();
    body.set('first_name', name);
    body.set('email', email);
    body.set('recaptcha_token', token);
    body.set('redirect', 'none');

    this.http.post(mcHammer, body.toString(), httpOptions).subscribe(
      (data) => {},
      (error) => {}
    );
  };
}
